import { useRoute } from "@/components/shared/router";
import { bookingRoutes } from "@/components/hooks/use-booking-route";
import { getServiceNameFromDepartment } from "@/lib/booking-lib";
import { useVisitDetailStore } from "@/store/visits/visitDetail";
import {
  useVisitIssueStore,
  VisitIssueType,
} from "@/store/report-issue/visit-issue/visitIssue";
import type { PackageDepartmentEnum } from "@/__generated__/graphql";

export const useVisitAction = () => {
  const { push } = useRoute();
  const openRateVisitModalById = useVisitDetailStore(
    (state) => state.openRateVisitModalById,
  );
  const openRescheduleVisitConfirmation = useVisitDetailStore(
    (state) => state.openRescheduleVisitConfirmation,
  );
  const openVisitIssueModal = useVisitIssueStore(
    (state) => state.openVisitIssueModal,
  );
  const handleViewDetail = useVisitDetailStore((state) => {
    return state.openVisitModal;
  });
  const handleRebook = (department: PackageDepartmentEnum) => {
    const serviceName = getServiceNameFromDepartment(department);
    push(bookingRoutes[serviceName][0]);
  };
  const handleSetSchedule = (visitId: string) => {
    openRescheduleVisitConfirmation(visitId);
  };
  const handleRateVisit = (visitId: string, rate?: number) => {
    // Store the visitId in the store so the modal can fetch it
    useVisitDetailStore.setState((state) => ({
      data: {
        ...state.data,
        visitId,
      },
    }));
    openRateVisitModalById(visitId, rate);
  };
  const handleReportVisit = (visitId: string) => {
    openVisitIssueModal(VisitIssueType.reportVisit, visitId, false);
  };
  return {
    handleViewDetail,
    handleRebook,
    handleSetSchedule,
    handleRateVisit,
    handleReportVisit,
  };
};
